function init(data)  
{
    ENV.customerEmail = data.customerEmail;
    ENV.customerCartId = data.customerCartId;
    ENV.customerSaveForLaterId = data.customerSaveForLaterId;
}

async function getCartInfo() {
    const cartObj = await fetch('/cart.json');
    const cartData = await cartObj.json();
    console.log(cartData);
}

async function moveToSaveForLater(lineitemKey, productId, variantId) {
    console.log(ENV.customerEmail);
    console.log('Move to Save For Later: ' + lineitemKey);

    var myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    fetch('/cart/change.js', {
        method: 'POST',
        headers: {  'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: lineitemKey,
            quantity: 0
        })
    })
    .then(response => { response.json() })
    .then(data => {
        console.log('Item removed from cart:', data);
        // add item to save for later
        fetch("/apps/f21/api/basket/saveforlater/add", 
        {
            method: "POST",
            headers: myHeaders,
            body: '{"email": "' + ENV.customerEmail + '", "productId": "gid://shopify/Product/' + productId + '", "productVariantId": "gid://shopify/ProductVariant/' + variantId + '"}',
            redirect: "follow"
        })
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            } else {
                return response.json();
            }
        })
        .then((result) => { 
            console.log(result);
            location.reload();
        });
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

function moveToCart(handle, productId, variantId) {
    console.log('Move to Cart: ' + productId + ' - ' + variantId);

    const parts = variantId.split('/');
    const SKU = parts[parts.length - 1];

    var myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    fetch('/products/' + handle + '.js')
    .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            } else {
                return response.json();
            }
        })
    .then(product => {
        const productTags = product.tags;
        const properties = {};
        if (productTags.includes('final_sale')) {
            properties['Final Sale'] = 'No Return';
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {  'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: SKU,
                quantity: 1,
                properties: properties
            })
        })
        .then(response => { response.json() })
        .then(data => {
            //console.log('Item added from cart:', data);
            // remove item from save for later
            fetch("/apps/f21/api/basket/saveforlater/remove", 
            {
                method: "POST",
                headers: myHeaders,
                body: '{"email": "' + ENV.customerEmail + '", "productId": "' + productId + '", "productVariantId": "' + variantId + '"}',
                redirect: "follow"
            })
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                } else {
                    return response.json();
                }
            })
            .then((result) => { 
                console.log(result);
                location.reload();
            });
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    });

    
}

function removeFromSaveForLater(productId, variantId) {
    console.log('Remove From Save For later: ' + productId + ' - ' + variantId);

    var myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    fetch("/apps/f21/api/basket/saveforlater/remove", 
    {
        method: "POST",
        headers: myHeaders,
        body: '{"email": "' + ENV.customerEmail + '", "productId": "' + productId + '", "productVariantId": "' + variantId + '"}',
        redirect: "follow"
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        } else {
            return response.json();
        }
    })
    .then((result) => { 
        console.log(result);
        location.reload();
    });
}

function renderSaveForLaterHTML() {
    const saveForLaterContainer = document.getElementById('SaveForLaterContainer');
    const saveForLaterSection = document.getElementById('SaveForLaterSection');

    var myHeaders = new Headers();
    myHeaders.append("User-Agent", "Shopify");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");

    if (ENV.customerEmail) {
        fetch("/apps/f21/api/basket/saveforlater", 
        {
            method: "POST",
            headers: myHeaders,
            body: '{"email": "' + ENV.customerEmail + '"}',
            redirect: "follow"
        })
        .then((response) => {
            if (!response.ok) {
                throw new Error("Network response was not ok");
            } else {
                return response.json();
            }
        })
        .then((result) => { 
            console.log(result);

            if (result && result.code == '00' && result.LineItems && result.LineItems.length > 0) {
                const productListHTML = result.LineItems.map(product => {
                    const allSizes = product.Variants.flatMap(item => {
                        return Array.isArray(item.Sizes) ? item.Sizes : [];
                    });
                    const formattedPrice = new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(product.ListPrice);
                    const selectedSKU = allSizes.find(variant => variant.VariantId === product.SelectedCartVariantId);
                    
                    return `
                    <tr>
                        <td>
                            <line-item class="line-item">
                                <img src="${product.SmallSizeProductImage}?v=1751196064&amp;width=1000" alt="0043991708#Color_BLUE" width="1000" height="1500" loading="lazy" sizes="(max-width: 699px) 70px, 120px" class="line-item__media">
                                <div class="line-item-info">
                                    <div class="v-stack justify-items-start gap-2">
                                        <div class="v-stack justify-items-start gap-1">
                                            <a href="/products/${product.ProductId}" class="h6">${product.DisplayName}</a>
                                            <price-list class="price-list ">
                                                <sale-price class="h6 text-subdued"><span class="sr-only">Sale price</span>${formattedPrice}</sale-price>
                                            </price-list>
                                        </div>
                                        <div class="v-stack justify-items-start gap-1">
                                            <p class="smallcaps text-subdued">${selectedSKU.Title}</p>
                                        </div>
                                        <line-item-quantity class="h-stack gap-4 sm:hidden">
                                        ${product.SelectedCartQuantity}
                                        <a href="javascript:removeFromSaveForLater('${product.ShopifyId}', '${product.SelectedCartVariantId}');" class="link text-xs" aria-label="Remove">
                                            Remove
                                        </a>
                                        <a href="javascript:moveToCart('${product.ProductId}', '${product.ShopifyId}', '${product.SelectedCartVariantId}');" class="link text-xs" aria-label="Move To Cart">
                                            Move To Cart
                                        </a>
                                        </line-item-quantity>
                                    </div>
                                </div>
                            </line-item>
                        </td>
                        <td class="text-center">
                            <div class="v-stack gap-2">
                                <line-item-quantity class="v-stack justify-items-center gap-2">
                                ${product.SelectedCartQuantity}
                                <a href="javascript:removeFromSaveForLater('${product.ShopifyId}', '${product.SelectedCartVariantId}');" class="link text-xs" aria-label="Remove">
                                    Remove
                                </a>
                                <a href="javascript:moveToCart('${product.ProductId}', '${product.ShopifyId}', '${product.SelectedCartVariantId}');" class="link text-xs" aria-label="Move To Cart">
                                    Move To Cart
                                </a>
                                </line-item-quantity>
                            </div>
                        </td>
                        <td class="text-end">
                            ${formattedPrice}
                        </td>
                    </tr>
                    `;
                    }).join('');
                
                //console.log(productListHTML);
                saveForLaterSection.innerHTML = productListHTML;
                saveForLaterContainer.classList.remove('hidden');
            }
        });
    }

    /*fetch("https://brandx-ec-proxyapi-dev.azurewebsites.net" + "/api/1/shopify/customer/saveforlater", 
    {
        method: "POST",
        headers: myHeaders,
        body: '{"email": "' + email + '"}',
        redirect: "follow"
    })
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        } else {
            return response.json();
        }
    })
    .then((result) => { 
        console.log(result);
    });
    */
    
}
document.addEventListener("cart:change", (event) => {
    if (event.detail.baseEvent === "variant:add") {
        if (ENV.customerEmail) {

            var cartCookie = getCookie('cart');
            if(decodeURIComponent(cartCookie.replace('gid://shopify/Cart/', '')) !== decodeURIComponent(ENV.customerCartId.replace('gid://shopify/Cart/', ''))) {
                var newCartId = '';
                var myHeaders = new Headers();
                myHeaders.append("User-Agent", "Shopify");
                myHeaders.append("Content-Type", "application/json");
                myHeaders.append("Access-Control-Allow-Origin", "*");
                
                // create new cart id
                fetch("/apps/f21/api/basket/createbasketid", 
                {
                    method: "POST",
                    headers: myHeaders,
                    body: JSON.stringify({
                        "email": ENV.customerEmail
                    }),
                    redirect: "follow"
                })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.json();
                })
                .then((cartinfo) => {
                    newCartId = decodeURIComponent(cartinfo.shopifyCartId.replace('gid://shopify/Cart/', ''));
                    // merge cart with existing cart and new cart
                    fetch("/apps/f21/api/basket/mergebasket/", 
                    {
                        method: "POST",
                        headers: myHeaders,
                        body: JSON.stringify({
                            "cartId": 'gid://shopify/Cart/' + newCartId,
                            "cartIdToBeMigrated": 'gid://shopify/Cart/' + cartCookie
                        }),
                    })
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error("Network response was not ok");
                        }
                        return response.json();
                    })
                    .then((mergeresult) => {
                        if (mergeresult.code !== "99") {
                            // update new cartId to customer
                            fetch("/apps/f21/api/basket/updateBasketIdToCustomer", 
                            {
                                method: "POST",
                                headers: myHeaders,
                                body: JSON.stringify({
                                    "email": ENV.customerEmail,
                                    "cartId": mergeresult.id,
                                }),
                                redirect: "follow"
                            })
                            .then((response) => {
                                if (!response.ok) {
                                    throw new Error("Network response was not ok");
                                }
                                return response.json();
                            })
                            .then((updateresult) => {
                                // overwrite cart cookie
                                const expireddate = new Date();
                                expireddate.setMonth(expireddate.getMonth() + 1);
                                document.cookie = 'cart=' + encodeURIComponent(mergeresult.id.replace('gid://shopify/Cart/', ''))
                                                + '; expires=' + expireddate.toUTCString()
                                                + '; path=/;';
                                location.reload();
                            } )
                            .catch((error) => console.error(error));
                        }
                    } )
                    .catch((error) => console.error(error));
                } )
                .catch((error) => console.error(error));
            }
        }
    }
});

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
}